'use client';

import { flex } from '@onbeam/business-styled-system/patterns';
import NextLink from 'next/link';
import { BeamVenturesLogo } from '@/icons/custom';
import { css } from '@onbeam/business-styled-system/css';
import { Button } from '@onbeam/business-ui';

export const Header = () => (
  <header
    className={flex({
      pos: 'relative',
      w: 'full',
      justify: 'space-between',
      align: 'center',
      maxW: '[90rem]',
      mx: 'auto',
      px: '6',
      py: '5',
      zIndex: 10,
      gap: '4',
      md: {
        py: '8',
        px: '10',
      },
    })}
  >
    <NextLink href="/">
      <BeamVenturesLogo
        className={css({
          smDown: {
            maxW: '[10rem]',
          },
        })}
      />
      <span className={css({ srOnly: true })}>Home</span>
    </NextLink>
    <div className={flex({ gap: '2' })}>
      <Button as="a" href="mailto:contact@beamventures.com">
        Contact Us
      </Button>
      {/* TODO: Place back once approved by Legal */}
      {/* <GetInvolvedButton /> */}
    </div>
  </header>
);
